import * as React from 'react';

import { useAtom, useAtomValue } from 'jotai';

import {
  $semaphorToken,
  $semaphorTokenValid,
  TOKEN_TTL,
} from '../_state/reports.state';

import { createMutationHook } from '~/shared/providers/api';

const useIntegrationsSemaphorGenerateTokenMutation = createMutationHook(
  'integrations.semaphorGenerateToken',
  () => ({
    integrationsSemaphorGenerateToken: {
      accessToken: true,
      refreshToken: true,
      dashboardId: true,
    },
  }),
);

export const useGenerateSemaphorToken = () => {
  const mutation = useIntegrationsSemaphorGenerateTokenMutation();
  const [cachedToken, setCachedToken] = useAtom($semaphorToken);
  const isValid = useAtomValue($semaphorTokenValid);

  React.useEffect(() => {
    if (isValid) return;
    mutation.mutate({});
  }, [isValid]);

  React.useEffect(() => {
    const result = mutation.data?.integrationsSemaphorGenerateToken;
    if (!result) return;

    setCachedToken({
      accessToken: result.accessToken,
      refreshToken: result.refreshToken,
      dashboardId: result.dashboardId,
      expiresAt: Date.now() + TOKEN_TTL,
    });
  }, [mutation.data, setCachedToken]);

  const tokenData =
    isValid && cachedToken
      ? cachedToken
      : mutation.data?.integrationsSemaphorGenerateToken;

  return {
    data: tokenData
      ? { integrationsSemaphorGenerateToken: tokenData }
      : undefined,
    loading: !isValid && mutation.isPending,
    error: mutation.error,
  };
};
